//@ts-nocheck
/**
 * Given a file, renames it to something uri safe
 * @param {File} file the file to rename
 * @param {string} group The group the image belongs to
 * @param {string} oldKey The old fileName
 * @returns The modified file
 */
export function renameFile(file, group, oldKey, fileNameOverride = "") {
	// Katie's photo bug was due to having a space in the filename that when un-encoded from the firestore url, puts a space in the link which causes the image to not render. This
	// sequence should squash any other dumb shit they put in a file name
	const extension = getFileExtension(file.name);
	const fileName = file.name.replace(/\.[^/.]+$/, ""); // The name without .png or whatever extension
	let fileNameToUse = file.name;
	// This check is to prevent a file from getting renamed after having already being renamed. Otherwise, it would get set to group/timestamp-group-timestamp-originalName.extension
	if (fileName !== oldKey) {
		if (fileNameOverride) {
			const parsedName = fileNameOverride.replace(/[^a-z0-9]/gi, "-");
			fileNameToUse = `${group}/${parsedName}-${Date.now()}${extension}`;
		} else {
			const parsedName = fileName.replace(/[^a-z0-9]/gi, "-"); // The name without any crazy characters in it. Just letters and numbers, anything else replaced by hyphens
			fileNameToUse = `${group}/${parsedName}-${Date.now()}${extension}`;
		}
	}

	const newFile = new File([file], fileNameToUse, {
		type: file.type,
		lastModified: file.lastModified,
	});
	return newFile;
}

/**
 * Returns the file extension from the end of a string, or '' if there's no file extension
 * @param {String} fileName The assumed filename of the template (eg. Management Data Form.docx)
 * @returns A file extension with '.' eg. .docx, .pdf. If there's no file extension, returns ""
 */
export function getFileExtension(fileName) {
	const typeMatch = fileName.match(/\.([^.]*)$/);
	const fileExtension = typeMatch ? typeMatch[0] : "";
	return fileExtension;
}
